import { createSelector } from 'reselect';

const selectLMScourses = (state: any) => state.lmsCourses;

export const selectLMScoursesCurrentItem = createSelector(
  [selectLMScourses],
  (lmsCourses) => lmsCourses.current
);

export const selectLMScoursesListItems = createSelector(
  [selectLMScourses],
  (lmsCourses) => lmsCourses.list
);

export const selectLMScoursesItemById = (itemId: any) =>
  createSelector(selectLMScoursesListItems, (list) =>
    list.result.items.find((item: any) => item._id === itemId)
  );

export const selectLMScoursesQueryItems = createSelector(
  [selectLMScourses],
  (lmsCourses) => lmsCourses.query
);

export const selectLMScoursesCreatedItem = createSelector(
  [selectLMScourses],
  (lmsCourses) => lmsCourses.create
);

export const selectLMScoursesUpdatedItem = createSelector(
  [selectLMScourses],
  (lmsCourses) => lmsCourses.update
);

export const selectLMScoursesReadItem = createSelector(
  [selectLMScourses],
  (lmsCourses) => lmsCourses.read
);

export const selectLMScoursesDeletedItem = createSelector(
  [selectLMScourses],
  (lmsCourses) => lmsCourses.delete
);

export const selectLMScoursesSearchedItems = createSelector(
  [selectLMScourses],
  (lmsCourses) => lmsCourses.search
);

export const selectLMScoursesItemsCount = createSelector(
  [selectLMScourses],
  (lmsCourses) => lmsCourses.count
);

export const selectLMScoursesItemsFilter = createSelector(
  [selectLMScourses],
  (lmsCourses) => lmsCourses.filter
);
